import React, {Component} from 'react';
import {connect} from "react-redux";
import {tokenId, userName, userRole} from '../../utilities/AuthService';
import {withRouter} from 'react-router';
import Sidebar from '../sections/Sidebar'
import * as storyActions from "../../actions/Story";
import ReactToPrint from "react-to-print";



function ToTitleCase(props)
{
    let str = props.name  ;
    return str.replace(/\b\w/g, function (txt) { return txt.toUpperCase(); });
}



class Listentries extends Component {

    constructor(props) {
        super(props);
        this.FilterList=this.FilterList.bind(this)
        this.ReadMore=this.ReadMore.bind(this)
        this.Selection  = this.Selection.bind(this)
        this.state={
            filter: '',
            userrole:userRole().userrole,
            encid:tokenId().id,
        }

    }

    FilterList(e){
        this.setState({filter:e.target.value})
    }



    componentDidMount() {
        let year = '2026';
        this.props.listallentries(this.state.encid,year);

    }


    ReadMore(e,id){
        console.log(id) ;
        window.location = "/readmore?id="+id+'&page=entries';

    }

    Selection(e){
        console.log(e.target.value) ;

    }







    render() {

        var lstories =  []  ;
        console.log(this.props.listentries.Entries.data) ;
        if (this.props.listentries.Entries.data !== undefined ){
            console.log("inside loop");
            console.log(this.props.listentries.Entries.data) ;
            if (this.state.filter !== "" ) {
                lstories = this.props.listentries.Entries.data.filter(
                    item => (item.fname.toLowerCase().search(this.state.filter.toLowerCase()) >= 0 )
                )

            }else{
                lstories =  this.props.listentries.Entries.data  ;

            }
        }


        return (
            <div className="page-content-holder">
                <Sidebar selection="entries" />
                <div className="tab-switching-panel-holder">
                    <div className="tab-switching-panel" id="users" >


                        <div className="intro-text">

                            <h4>Dear {userName().fname} {userName().lname},</h4>
                            <p>Welcome to the online judging of EAF Awards.</p>

                            <p>Thank you for volunteering your precious time to evaluate the work of aspiring journalists.</p>
                            <p>Clicking on the name of the entrant will take you to her/his article.</p>
                            <p>Though the basic criteria of judging will be quality/relevance of content, perspective, original thinking, expression, style and language, your unique eye and sensibility would be what matters the most.</p>
                            <p>Please rate the article based on the criteria given and then click "Submit & Continue Evaluation."</p>
                            <p>You can exit and continue judging whenever you want to. </p>

                            <h4>We request you to complete the judging on or before 31 March 2026.  </h4>
                            <p>Once again, thank you for your valuable contribution to the EAF Awards.</p>
                            <p>If you have questions with the judging process, feel free to write to <a href="mailto:swarupbr@gmail.com">swarupbr@gmail.com</a> or call 9846122376.</p>

                            <h4>2026 topic</h4>
                           {/* <p><strong>How Can We Save Kerala's Monsoon Dream-Season From Becoming A Recurring Nightmare?</strong></p>
                            <p>Every media vehicle has made its recommendations - visionary thinking, people-centric long-term planning and implementation, political will, integrating environment sustainability into everything - the list is endless. Kerala definitely needs a new sustainable model of development - and the answer perhaps lies in the middle ground between the two distinctly diverse schools of thought developing in this space. How deep can you dig? How high can you fly? How many planned conversations can you have? How interesting a perspective can you shed?</p>*/}

                            {/*<p><strong>Welcome to the 2026 edition of the E A Fernandez Award for aspiring journalists. </strong></p>*/}
                            {/*<p>We invite you to study the socio-economic transformation of a village in Kerala through tourism.</p>*/}
                            <p><strong>AI in God&apos;s Own Country: How Much Will AI Reshape Kerala&apos;s IT Workforce?</strong></p>

                            <p><strong>The Context:</strong></p>

                            <p>Sandeep, a software engineer, stares at his screen as an AI tool generates in minutes what would have taken him hours to code, wondering if their next appraisal will be their last. There is a cloud hanging over thousands of people like Sandeep.</p>

                            <p>Throughout history, technological revolutions have initially sparked fear among workers – especially computers that were supposed to eliminate office jobs. Each time, humanity adapted, learned new skills, and emerged stronger and more capable than before.</p>

                            <p>But this time around, will it be the same?</p>

                            <p>Artificial Intelligence is poised to fundamentally transform Kerala&apos;s IT workforce over the next two to three years. Unlike previous technological shifts, AI threatens to automate cognitive tasks that form the backbone of Kerala&apos;s knowledge economy.</p>

                            <p>We invite you to deep dive into this space and tell this story through the lived experiences of real people - weaving together personal narratives with data, interviews, and multimedia elements to capture how AI is reshaping not just jobs, but lives, dreams, and futures in God&apos;s Own Country.</p>

                            <p><strong>The Assignment:</strong></p>

                            <p>Study how AI will impact Kerala&apos;s IT workforce. This is not an academic exercise about artificial intelligence in general, but a deeply human story about specific people facing unprecedented change.</p>

                            <p>Your story should centre around one compelling human narrative - perhaps a junior developer learning to work with AI coding assistants, a QA tester whose role is being automated, or a technical writer navigating AI writing tools. Use this personal story as the foundation, then build outward with supporting interviews, data, and analysis.</p>

                            <p><strong>Key Areas That Can Be Explored:</strong></p>

                            <p><strong>Job Roles Under Pressure:</strong></p>
                            <ul>
                                <li>Junior developers and the rise of AI coding assistants</li>
                                <li>Quality Assurance testers facing test automation</li>
                                <li>Technical writers adapting to AI writing tools</li>
                                <li>Data entry and basic coding roles being AI-enhanced</li>
                                <li>Customer support roles transitioning due to chatbots</li>
                            </ul>

                            <p><strong>The Human Response:</strong></p>
                            <ul>
                                <li>How are workers adapting and reskilling?</li>
                                <li>What new roles are emerging as others disappear?</li>
                                <li>How are companies handling this transition?</li>
                                <li>What support systems exist for displaced workers?</li>
                                <li>How are owners responding to the change? What is their idea of the future? Will they re-design the organisation and invest further in technology? What will be their saving in terms of labour?</li>
                                <li>How are educational institutions preparing the next generation?</li>
                            </ul>

                            <p><strong>The Ripple Effects:</strong></p>
                            <ul>
                                <li>Impact on families and personal finances</li>
                                <li>Changes in career planning and expectations</li>
                                <li>Psychological effects of job uncertainty</li>
                                <li>Community responses and support networks</li>
                            </ul>

                            <p><strong>Research Requirements:</strong></p>

                            <p><strong>Primary Interviews (Minimum 7-12 people):</strong></p>
                            <ul>
                                <li>IT personnel across different experience levels and roles</li>
                                <li>HR managers and team leads discussing AI adoption strategies</li>
                                <li>Recent graduates entering a transformed job market</li>
                                <li>Training heads adapting curricula for an AI world</li>
                                <li>Career counsellors helping workers navigate transitions</li>
                                <li>Family members of affected IT workers</li>
                                <li>Industry experts and local tech leaders</li>
                            </ul>

                            <p><strong>Data Collection:</strong></p>
                            <ul>
                                <li>Specific examples of AI tools being implemented</li>
                                <li>Reskilling program enrollment and success rates</li>
                                <li>Salary and job posting trends in affected roles</li>
                                <li>Case studies of companies that have significantly adopted AI</li>
                                <li>Government skill development centres that are redesigning programs</li>
                            </ul>

                            <p><strong>Avoid These Approaches:</strong></p>
                            <ul>
                                <li>Generic narratives / discussions about AI without specific local context</li>
                                <li>Technology-focused narratives that lose sight of human impact</li>
                                <li>Broad surveys without deep personal stories</li>
                                <li>Academic analysis without ground-level reporting</li>
                                <li>Speculation without evidence from real Technopark experiences</li>
                            </ul>

                            <p><strong>What We&apos;re Looking For:</strong></p>

                            <p>Your 3000-word multimedia story should narrate how AI is changing not just what people do at work, but how they see their futures, plan their careers, and navigate their lives in the State of Kerala – especially in IT hubs like Thiruvananthapuram and Kochi.</p>

                            <p>Focus on your unique perspective and human story rather than attempting to cover every aspect of AI&apos;s impact. The best stories will make readers feel they understand what it&apos;s like to live through this transformation, supported by rigorous reporting and compelling multimedia elements.</p>

                            <p>This story should be grounded in the specific reality, while illuminating broader questions about technology, work, and human adaptation that resonate far beyond Kerala&apos;s borders.</p>

                            <p><strong>Recommended Time Management:</strong></p>
                            <ul>
                                <li><strong>Month 1:</strong> Background research, identification of your central character and supporting interview subjects, development of interview protocols.</li>
                                <li><strong>Month 2:</strong> Intensive field study, including all interviews, data collection, and multimedia documentation</li>
                                <li><strong>Month 3:</strong> Data analysis, story writing, and submission of the multimedia report</li>
                            </ul>

                            <p>By working on this in-depth story, you&apos;ll gain valuable experience in slow journalism while contributing to the community’s understanding of how global technological transformation affects real people in real places.</p>

                            <p>All the very best.</p>

                            <br/>
                            <p><strong>ദൈവത്തിന്റെ സ്വന്തം നാട്ടിൽ AI</strong></p>
                            <p><strong>കേരളത്തിലെ IT തൊഴിൽ രംഗത്തെ നിർമിത ബുദ്ധി എങ്ങനെ മാറ്റിമറിക്കും?</strong></p>

                            <p><strong>സന്ദർഭം</strong></p>

                            <p>സന്ദീപ്, ചെറുപ്പക്കാരനായ ഒരു സോഫ്റ്റ്‌വെയർ എഞ്ചിനീയർ തന്റെ മുന്നിലുള്ള സ്ക്രീനിലേക്ക് നോക്കി അമ്പരന്നിരിക്കുന്നു. തനിക്ക് മണിക്കൂറുകൾ വേണ്ട സ്ഥാനത്ത് ഒരു AI ടൂൾ നിമിഷങ്ങൾക്കുള്ളിൽ കോഡ് ചെയ്തു തീർക്കുന്നു. തന്റെ അടുത്ത അപ്പ്രൈസൽ അവസാനത്തേത് കൂടി ആയിരിക്കുമോ എന്ന് അയാൾ ഭയക്കുന്നു.</p>
                            <p>സന്ദീപിനെപ്പോലുള്ള ആയിരക്കണക്കിന് ചെറുപ്പക്കാരുടെ ഭാവി അനിശ്ചിതത്വത്തിൽ ആയിരിക്കുന്നു.</p>

                            <p>ചരിത്രത്തിൽ എല്ലായ്പ്പോഴും സാങ്കേതിക വിപ്ലവങ്ങൾ തൊഴിലാളികളിൽ ഭയം സൃഷ്ടിച്ചിട്ടുണ്ട്. കംപ്യൂട്ടറുകൾ ജോലി ഇല്ലാതാക്കും എന്ന ഭയം വ്യാപകമായിരുന്നു. എന്നാൽ ഓരോ സമയത്തും മാനവരാശി ഈ മാറ്റത്തോട് താദാത്മ്യം പ്രാപുകയും പുതിയ സ്കില്ലുകൾ പഠിക്കുകയും മുൻപത്തേക്കാൾ കൂടുതൽ കഴിവുകൾ ആർജിച്ച് മുന്നോട്ട് പോവുകയും ചെയ്തു.</p>

                            <p>എന്നാൽ ഇത്തവണ സ്ഥിതി വിഭിന്നമാണോ?</p>

                            <p>അടുത്ത രണ്ടോ മൂന്നോ വർഷത്തിനുള്ളിൽ നിർമിത ബുദ്ധി കേരളത്തിലെ തൊഴിൽ രംഗത്തെ സമൂലമായി മാറ്റാൻ പോവുകയാണ്. കേരളത്തിന്റെ സമ്പത് ഘടനയുടെ ചാലക ശക്തിയാകാൻ പോകുന്ന വിജ്ഞാന സമ്പത്ഘടനയെയാണ് ഇത് ഏറ്റവും കൂടുതൽ ബാധിക്കുക.</p>

                            <p>ഈ രംഗത്ത് പ്രവർത്തിക്കുന്നവരുടെ യഥാർത്ഥ ജീവിതാനുഭവങ്ങളിലൂടെ ഈ മാറ്റത്തെ സമഗ്രമായി പഠിച്ച്‌ കേരളത്തിന്റെ തൊഴിൽ മേഖലയുടെ ഭാവി പരിശോധിക്കാൻ ഞങ്ങൾ നിങ്ങളെ ക്ഷണിക്കുന്നു. വ്യക്തികളുമായി സംസാരിച്ചും ലഭ്യമായ വിവരശേഖരം ഉപയോഗിച്ചും മൾട്ടി മീഡിയ സങ്കേതങ്ങൾ ഉപയോഗിച്ചും നിർമിത ബുദ്ധി കേരളത്തിലെ യുവജനതയുടെ ഭാവിയും സ്വപ്നങ്ങളും ജീവിതവും എങ്ങനെ മാറ്റിത്തീർക്കും എന്നതാണ് നിങ്ങൾ പഠിക്കേണ്ടത്.</p>

                            <p><strong>അസൈൻമെന്റ്</strong></p>

                            <p>നിർമിത ബുദ്ധി കേരളത്തിന്റെ തൊഴിൽ രംഗത്തുണ്ടാക്കുന്ന മാറ്റങ്ങൾ പഠിക്കുക. ഇത് ഒരു അക്കാഡമിക് പഠനമല്ല. മറിച്ച് അപ്രതീക്ഷിതമായുണ്ടാകുന്ന മാറ്റങ്ങൾ സാധാരണ മനുഷ്യരുടെ ജീവിതത്തെ എങ്ങനെ മാറ്റുന്നു എന്നതിന്റെ ആഖ്യാനമാണ്.</p>

                            <p>ഒരു വ്യക്തിയുടെ ജീവിതത്തിലൂടെയാണ് നിങ്ങൾ കഥ പറയേണ്ടത്. AI കോഡിങ് ചെയ്യുന്ന ഒരു ജൂനിയർ ഡെവലപ്പർ, ഒരു QA ടെസ്റ്റർ, ഒരു ടെക്നിക്കൽ റൈറ്റർ അതുമല്ലെങ്കിൽ ഈ മേഖലയിൽ AI മൂലം ജോലി നഷ്ടപ്പെടാൻ സാധ്യതയുള്ള ഏതെങ്കിലും ഒരു വ്യക്തിയുടെ ജീവിതകഥയിലൂടെയാണ് സാങ്കേതിക രംഗത്തെ ഈ മാറ്റം നിങ്ങൾ അവതരിപ്പിക്കേണ്ടത്. ഇതിന് സഹായകരമായ അനുബന്ധ വിവരങ്ങൾ, അഭിമുഖങ്ങൾ, വിശകലനം എന്നിവയും ഉണ്ടാവണം.</p>

                            <p><strong>പരിശോധിക്കേണ്ട പ്രധാന മേഖലകൾ</strong></p>

                            <p><strong>സമ്മർദ്ദത്തിലാവുന്ന തൊഴിലുകൾ</strong></p>
                            <ul>
                                <li>AI കോഡിങ് അസിസ്റ്റന്റ്‌സിന്റെ വരവും ജൂനിയർ ഡെവലപ്പർമാരും</li>
                                <li>ടെസ്റ്റ് ഓട്ടോമേഷനും ക്വാളിറ്റി അഷുറൻസ് ടെസ്റ്റർമാരും</li>
                                <li>ഡാറ്റ എൻട്രി, ബേസിക് കോഡിങ് മേഖലകൾ</li>
                                <li>ചാറ്റ് ബോക്സിലേക്ക് മാറുന്ന കസ്റ്റമർ സപ്പോർട്ട് ജോലികൾ</li>
                            </ul>

                            <p><strong>വ്യക്തികളുടെ പ്രതികരണം</strong></p>
                            <ul>
                                <li>ജീവനക്കാർ എങ്ങനെയാണ് പുതിയ സ്കില്ലുകൾ പഠിക്കുകയും മാറ്റത്തോട് പൊരുത്തപ്പെടുകയും ചെയ്യുന്നത്</li>
                                <li>ചില റോളുകൾ നഷ്ടമാകുമ്പോൾ പുതിയതായി സൃഷ്ടിക്കപ്പെടുന്ന റോളുകൾ എന്തായിരിക്കും?</li>
                                <li>മാറ്റത്തെ കമ്പനികൾ എങ്ങനെയാണ് സ്വീകരിക്കുന്നത്?</li>
                                <li>തൊഴിൽ നഷ്ടമാകുന്ന ജീവനക്കാർക്കുള്ള സഹായ സംവിധാനങ്ങൾ എന്തൊക്കെയാണ്?</li>
                                <li>കമ്പനി ഉടമകൾ ഈ മാറ്റത്തെ എങ്ങനെ കാണുന്നു? ഭാവിയെക്കുറിച്ച് അവരുടെ ധാരണ എന്താണ്? അവർ കമ്പനികളുടെ ഘടനയിൽ മാറ്റം വരുത്തുകയും കൂടുതൽ സാങ്കേതിക വിദ്യകളിൽ നിക്ഷേപം വർധിപ്പിക്കുകയും ചെയ്യുമോ? തൊഴിലാളികളുടെ എണ്ണത്തിൽ കുറവ് വരുത്തുന്നതോടെ അവർക്ക് പ്രതീക്ഷിക്കുന്ന ലാഭം എന്താണ്?</li>
                                <li>വിദ്യാഭ്യാസ സ്ഥാപനങ്ങൾ പുതിയ തലമുറയെ ഈ മാറ്റത്തിനായി എങ്ങനെ തയ്യാറാക്കുന്നു?</li>
                            </ul>

                            <p><strong>മറ്റ് അനുബന്ധ സാമൂഹിക പ്രശ്നങ്ങൾ</strong></p>
                            <ul>
                                <li>കുടുംബത്തിലും വ്യക്തികളുടെ സാമ്പത്തിക അവസ്ഥയിലും ഉണ്ടാകുന്ന ആഘാതം</li>
                                <li>കരിയർ പ്ലാനിങ്ങിലും പ്രതീക്ഷകളിലും വരുന്ന മാറ്റം</li>
                                <li>തൊഴിൽ രംഗത്തെ അനിശ്ചിതത്വം സൃഷ്ടിക്കുന്ന മാനസിക പ്രശ്നങ്ങൾ</li>
                                <li>സമൂഹത്തിന്റെ പ്രതികരണവും പിന്തുണയ്ക്കായുള്ള സംവിധാനങ്ങളും</li>
                            </ul>

                            <p><strong>പഠനത്തിനായി ഉപയോഗിക്കേണ്ടതെന്തൊക്കെ?</strong></p>

                            <p><strong>പ്രാഥമികമായും അഭിമുഖങ്ങൾ (7-12 പേരുമായുള്ള വ്യക്തിപരമായ സംഭാഷണങ്ങൾ)</strong></p>
                            <ul>
                                <li>IT രംഗത്തെ ജീവനക്കാർ: പല തലങ്ങളിൽ പരിചയവും വൈദഗ്ധ്യവും ഉള്ളവർ</li>
                                <li>HR മാനേജർ, ടീം ലീഡ്: നിർമിത ബുദ്ധിയുമായി പൊരുത്തപ്പെടുന്നതെങ്ങനെ</li>
                                <li>ഇപ്പോൾ പഠിച്ചിറങ്ങിയവർ: മാറുന്ന തൊഴില്മേഖലകളിലേക്കുള്ള പ്രവേശം</li>
                                <li>ട്രെയിനിങ് ഹെഡ്സ്: AI ലോകത്തിന് വേണ്ടി കരിക്കുലത്തിൽ വരുത്തേണ്ട മാറ്റം</li>
                                <li>കരിയർ കൗൺസലേഴ്സ്: മാറ്റത്തിനെ ഉൾക്കൊള്ളാൻ യുവാക്കളെ പര്യാപ്തരാക്കുക</li>
                                <li>കുടുംബാംഗങ്ങൾ: പ്രത്യേകിച്ച് ഈ മാറ്റം പ്രതികൂലമായി ബാധിച്ചവരുടെ കുടുംബം</li>
                                <li>ഇൻഡസ്ട്രി വിദഗ്ധർ: ഒപ്പം നമ്മുടെ നാട്ടിലെ സാങ്കേതിക വിദഗ്ധർ</li>
                            </ul>

                            <p><strong>ഡാറ്റ ശേഖരണം</strong></p>
                            <ul>
                                <li>ഇപ്പോൾ ഉപയോഗിക്കുന്ന AI ടൂൾസ്</li>
                                <li>പുതിയ സ്കില്ലുകൾക്കായുള്ള പരിശീലനം, അതിൽ പങ്കെടുക്കുന്നവരുടെ എണ്ണം</li>
                                <li>ജോലിയുടെ അളവിലും ശമ്പളത്തിലും വരുന്ന മാറ്റം</li>
                                <li>ധാരാളമായി AI ഉപയോഗിക്കുന്ന കമ്പനികളുടെ കേസ് സ്റ്റഡി</li>
                                <li>ഗവണ്മെന്റ് സ്കിൽ ഡെവലപ്മെന്റ് കേന്ദ്രങ്ങളും പ്രോഗ്രാം റീഡിസൈനും</li>
                            </ul>

                            <p><strong>ഒഴിവാക്കേണ്ട കാര്യങ്ങൾ</strong></p>
                            <ul>
                                <li>കൃത്യമായ പ്രാദേശിക ഉദാഹാരണങ്ങൾ ഇല്ലാതെ പൊതുവായിട്ടുള്ള വിശദീകരണങ്ങൾ</li>
                                <li>വ്യക്തിപരമായ കഥകൾക്കുള്ള ഊന്നൽ നഷ്ടപ്പെടുത്തി സാങ്കേതികതയിൽ ഊന്നിയ വിവരണം</li>
                                <li>വ്യക്തികളുടെ കഥകൾ ഇല്ലാത്ത പൊതുവായ സർവ്വേ</li>
                                <li>താഴെത്തട്ടിലുള്ള റിപ്പോർട്ടിങ് ഇല്ലാത്ത അക്കാഡമിക് അപഗ്രഥനം</li>
                                <li>ടെക്നോപാർക്ക് പോലുള്ള സ്ഥാപനങ്ങളിൽ നിന്നുള്ള തെളിവിന്റെ അടിസ്ഥാനത്തിൽ അല്ലാതെയുള്ള ഊഹക്കണക്കുകൾ</li>
                            </ul>

                            <p><strong>ഞങ്ങൾ എന്താണ് പ്രതീക്ഷിക്കുന്നത്?</strong></p>

                            <p>3000 വാക്കുകൾ എങ്കിലുമുള്ള ഒരു മൾട്ടീമീഡിയ സ്റ്റോറിയാണ് നിങ്ങൾ നൽകേണ്ടത്. ഇതിൽ നിർമിത ബുദ്ധി എങ്ങനെയാണ് തൊഴിലിൽ മാറ്റം വരുത്തുന്നത് എന്ന് മാത്രമല്ല മനുഷ്യരുടെ ആശങ്കൾ, ഭാവി, ജോലിയുടെ ആസൂത്രണം എന്നിങ്ങനെ അവരുടെ ജീവിതത്തെ സംബന്ധിച്ചുള്ള പഠനമാണ് ഉണ്ടാവേണ്ടത്. തിരുവനന്തപുരം, കൊച്ചി IT ഹബ്ബുകളിൽ പണിയെടുക്കുന്നവരുടെ യഥാർത്ഥ ജീവിത കഥയാണ് വേണ്ടത്.</p>

                            <p>AI യുടെ സ്വാധീനത്തെക്കുറിച്ചുള്ള പൊതു വിവരണത്തേക്കാൾ നിങ്ങളുടെ സവിശേഷമായ കാഴ്ചപ്പാടിൽ ഉരുത്തിരിയുന്ന വ്യക്തിപരമായ കഥയായിരിക്കണം തയ്യാറാക്കുന്നത്. ഈ മാറ്റത്തിലൂടെ കടന്നുപോകുന്നവരുടെ ജീവിതത്തെ ആഴത്തിൽ മനസ്സിലാക്കാൻ വായനക്കാർക്ക് കഴിയണം. ഇതിനായി കൃത്യമായ വിവര ശേഖരണവും അപഗ്രഥനവും മൾട്ടീമീഡിയ അവതരണവും ഉണ്ടാവണം.</p>

                            <p>കേരളത്തിന്റെ യാഥാർഥ്യത്തെ പ്രതിഫലിക്കുന്നതാവണം നിങ്ങൾ തയ്യാറാക്കുന്ന റിപ്പോർട്ട്. അതേസമയം സാങ്കേതിക വിദ്യ, തൊഴിൽ മേഖല, മനുഷ്യർ ഇത്തരം പ്രശ്നങ്ങളുമായി പൊരുത്തപ്പെടുന്ന രീതി തുടങ്ങിയ പ്രശ്നങ്ങളെക്കുറിച്ച് കേരളത്തിന്റെ അതിർത്തിയ്ക്കപ്പുറത്തേക്കുകൂടി വ്യാപിക്കും വിധം വെളിച്ചം വീശുന്ന രീതിയിലാവണം നിങ്ങൾ എഴുതുന്നത്.</p>

                            <p><strong>ടൈം ലൈൻ</strong></p>
                            <ul>
                                <li><strong>മാസം ഒന്ന്:</strong> പശ്ചാത്തല ഗവേഷണം, അഭിമുഖം നടത്തേണ്ട പ്രധാന വ്യക്തിയെയും മറ്റുള്ളവരെയും കണ്ടെത്തൽ, അഭിമുഖത്തിനായുള്ള ചോദ്യങ്ങൾ തയ്യാറാക്കൽ</li>
                                <li><strong>മാസം രണ്ട്:</strong> IT അനുബന്ധ മേഖലകളിൽ നടത്തുന്ന തീവ്രമായ പഠനം, അഭിമുഖങ്ങൾ, വിവര ശേഖരണം, മൾട്ടീമീഡിയ ഡോക്യൂമെന്റേഷൻ</li>
                                <li><strong>മാസം മൂന്ന്:</strong> വിവരങ്ങളുടെ അപഗ്രഥനം, സ്റ്റോറി റൈറ്റിങ്, മൾട്ടി മീഡിയ റിപ്പോർട്ട് സമർപ്പിക്കൽ</li>
                            </ul>

                            <p>ഈ വിഷയം ആഴത്തിൽ പഠിക്കുന്നതോടെ സ്ലോ ജേർണലിസത്തിൽ നിങ്ങൾ പ്രാവീണ്യം നേടുകയാണ്. അതോടൊപ്പം തന്നെ സാങ്കേതിക മേഖലകളിൽ ഉണ്ടാവുന്ന മാറ്റം നമ്മുടെ നാട്ടിലെ സാധാരണ മനുഷ്യരുടെ ജീവിതത്തെ എങ്ങനെയാണ് മാറ്റുന്നത് എന്ന് പഠിക്കുകയും സമൂഹത്തിലേക്ക് അത് പകർന്നുനൽകുകയുമാണ്.</p>

                            <p>എല്ലാ ആശംസകളും.</p>


                        </div>

                        <div className="panel-options-head entries">
                            <h5>Entries</h5>
                            <ReactToPrint
                                trigger={() => <a className="btn print-btn icon-btn icon-btn--print" href="#">Print Entries</a>}
                                content={() => this.componentRef}
                            />
                        </div>
                        <div className="panel-options-content" >
                            <div className="scrollable table-wrapper">
                                <table className="user-table table-in"  ref={el => (this.componentRef = el)}>
                                    <thead>
                                    <tr>

                                        <th>Name</th>

                                        {/*<th>Score</th>*/}
                                        <th>Marks</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    { lstories.map((list,index) =>

<tr  key={`list-shortlisted-table-data-`+index}  className="show-click" onClick={(e) => this.ReadMore(e,list.storyid)}>


                                            <td>

                                                <label className="sl-no">{index+1}</label>
                                                <label className="inline-text">{list.fname} {list.lname}</label>
                                            </td>

                                            {/*<td>{list.remarks}</td>*/}
                                            <td>{list.marks}</td>

                                        </tr>
                                    )}
                                    </tbody>





                                </table>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        );

    }
}


const mapStateToProps = state => ({
    listentries:state.StoryReducer.ListEntries,


});



export default  withRouter(connect(mapStateToProps, {
    listallentries:storyActions.listAllEntries
})(Listentries));